export const translateErrorMessage = (err: string): string => {
    switch (err) {
    case 'Personal rate already exists!': return 'Индивидуальная цена для данного партнёра в этом оффере уже настроена. Вам нужно отредактировать её, а не создавать новую.';
    default: return err;
    }
};
